<template>
  <BaseChart
    :chart-data="chartData"
    :chart-options="getChartOptions"
  />
</template>

<script>
import BaseChart from './BaseChart.vue';

export default {
  name: 'PieChart',
  components: { BaseChart },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  computed: {
    getChartOptions () {
      return {
        data: [{
          type: 'pie',
          showInLegend: true,
          toolTipContent: '{indexLabel}: {y} | #percent %',
          legendText: '{indexLabel}',
          dataPoints: this.chartData.values?.map(item => ({
            y: item.count,
            indexLabel: item.value,
            color: item.color,
            click: () => this.handleClick(item.to)
          })) || []
        }]
      };
    }
  },
  methods: {
    handleClick (to) {
      if (to) {
        this.$router.push(to);
      }
    }
  }
};
</script>
